<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>Capitalism 3.0</h1>
<p class="subtitle"><span class="small">A GUIDE TO RECLAIMING THE COMMONS</span></p>
<p class="author">PETER BARNES</p>
<p class="publisher"><img alt="Image" src="Images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?145c4838